import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IncomingInvoiceProfile, Supplier } from "models/propTypes/userProfilePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { GenericPaymentListProps } from "models/propTypes/paymentPropTypes";
import { Amount } from "models/utilTypes/currencyType";
//#endregion
//#region components
import PaymentList from "../paymentListTable";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const IncomingInvoicePaymentList: React.FC<GenericPaymentListProps> = (props) => {
  return (
    <PaymentList
      properties={{
        supplierName: {
          description: TranslationKeys.IncomingInvoice.Supplier,
          formatter: (values: WintSuperkollAPIModel.IncomingInvoicePaymentListItem) =>
            new Supplier(values.supplierId, values.supplierName, undefined, props.onUserProfileClick),
          noWrap: true,
          width: "20%",
        },
        paymentDate: {
          description: TranslationKeys.Common.Date,
          formatter: (values: WintSuperkollAPIModel.IncomingInvoicePaymentListItem) => new Date(values.paymentDate),
          noWrap: true,
          width: "15%",
        },
        dueDate: {
          formatter: (values: WintSuperkollAPIModel.IncomingInvoicePaymentListItem) =>
            values.dueDate && new Date(values.dueDate),
          description: TranslationKeys.Common.Due_Date,
          noWrap: true,
          width: "15%",
        },
        invoiceNumber: {
          formatter: (values: WintSuperkollAPIModel.IncomingInvoicePaymentListItem) =>
            new IncomingInvoiceProfile(values.incomingInvoiceId ?? 0, values.invoiceNumber?.toString() ?? ""),
          description: TranslationKeys.Common.Number,
          className: cssExports.textBlue,
          alignment: "right",
          noWrap: true,
          width: "25%",
        },
        amount: {
          formatter: (values: WintSuperkollAPIModel.IncomingInvoicePaymentListItem) =>
            values.amount && new Amount(values.amount.type, values.amount.value),
          description: TranslationKeys.Common.Amount,
          noWrap: true,
          className: cssExports.textBlack,
          alignment: "right",
          width: "25%",
        },
      }}
      items={props.items ?? []}
      disableRowSelection={props.disableRowSelection}
      onRowSelectionsChange={props.onRowSelectionsChange}
    ></PaymentList>
  );
};

export default IncomingInvoicePaymentList;
